import { render, staticRenderFns } from "./MFormSelect.vue?vue&type=template&id=7fa272ba&"
import script from "./MFormSelect.vue?vue&type=script&lang=js&"
export * from "./MFormSelect.vue?vue&type=script&lang=js&"
import style0 from "./MFormSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports